import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * KPI
 */
const kPI = {

  /**
   * 创建
   */
  createKPIGroup (companyId, name, displayName) {
    return axios.post(base.kpi.createKPIGroup, utils.postParamsArrayToJsonString({ companyId, name, displayName }))
  },
  /**
   * 修改
   */
  modifyKPIGroup (id, name, displayName) {
    return axios.post(base.kpi.modifyKPIGroup, utils.postParamsArrayToJsonString({ id, name, displayName }))
  },
  /**
   * 删除
   */
  deleteKPIGroup (id) {
    return axios.post(base.kpi.deleteKPIGroup, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getKPIGroup (id) {
    return axios.post(base.kpi.getKPIGroup, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getKPIGroup2 (companyId) {
    return axios.post(base.kpi.getKPIGroup2, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 添加
   */
  addKPI (groupId, name, displayName) {
    return axios.post(base.kpi.addKPI, utils.postParamsArrayToJsonString({ groupId, name, displayName }))
  },
  /**
   * 修改
   */
  modifyKPI (id, name, displayName) {
    return axios.post(base.kpi.modifyKPI, utils.postParamsArrayToJsonString({ id, name, displayName }))
  },
  /**
   * 删除
   */
  deleteKPI (id) {
    return axios.post(base.kpi.deleteKPI, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getKPI (id) {
    return axios.post(base.kpi.getKPI, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getKPI2 (id) {
    return axios.post(base.kpi.getKPI2, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 添加
   */
  addKPIValue (id, startTime, endTime, upperBound, lowerBound) {
    return axios.post(base.kpi.addKPIValue, utils.postParamsArrayToJsonString({ id, startTime, endTime, upperBound, lowerBound }))
  },
  /**
   * 修改
   */
  modifyKPIValue (id, startTime, endTime, upperBound, lowerBound) {
    return axios.post(base.kpi.modifyKPIValue, utils.postParamsArrayToJsonString({ id, startTime, endTime, upperBound, lowerBound }))
  },
  /**
   * 删除
   */
  deleteKPIValue (id) {
    return axios.post(base.kpi.deleteKPIValue, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getKPIValue (id) {
    return axios.post(base.kpi.getKPIValue, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getKPIValue2 (id) {
    return axios.post(base.kpi.getKPIValue2, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getKPIValue3 (id) {
    return axios.post(base.kpi.getKPIValue3, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getKPIValue4 (companyId, groupName, kpiName) {
    return axios.post(base.kpi.getKPIValue4, utils.postParamsArrayToJsonString({ companyId, groupName, kpiName }))
  },
  /**
   * 增加
   */
  addMeasureUsingKPI (measureId, expressionName, KPIGroupId) {
    return axios.post(base.kpi.addMeasureUsingKPI, utils.postParamsArrayToJsonString({ measureId, expressionName, KPIGroupId }))
  },
  /**
   * 增加
   */
  addMeasureUsingKPI2 (measuresId, expressionName, KPIGroupId) {
    return axios.post(base.kpi.addMeasureUsingKPI2, utils.postParamsArrayToJsonString({ measuresId, expressionName, KPIGroupId }))
  },
  /**
   * 增加
   */
  addMeasureUsingKPI3 (measures, KPIGroupId) {
    return axios.post(base.kpi.addMeasureUsingKPI3, utils.postParamsArrayToJsonString({ measures, KPIGroupId }))
  },
  /**
   * 修改
   */
  modifyMeasureUsingKPI (id, expressionName, KPIGroupId) {
    return axios.post(base.kpi.modifyMeasureUsingKPI, utils.postParamsArrayToJsonString({ id, expressionName, KPIGroupId }))
  },
  /**
   * 删除
   */
  deleteMeasureUsingKPI (id) {
    return axios.post(base.kpi.deleteMeasureUsingKPI, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getMeasureUsingKPI (measureId) {
    return axios.post(base.kpi.getMeasureUsingKPI, utils.postParamsArrayToJsonString({ measureId }))
  },
  /**
   * 根据KPI组查询
   */
  getUsingKPIByGroupId (groupId) {
    return axios.post(base.kpi.getUsingKPIByGroupId, utils.postParamsArrayToJsonString({ groupId }))
  },
}

export default kPI